import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useCreatorIntegrationsQuery = createQueryHook(
  CreatorIntegrationsApiClient.getCreatorIntegrations,
  {
    queryKey: ['creatorIntegrations'],
  },
)
